module.exports = ".lui-logo__seed{display:inline-block;height:var(--lui-reduced-control-height);vertical-align:middle;width:var(--lui-reduced-control-height)}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-logo/theme/lui-logo.scss
// module id = 234
// module chunks = 0 1 10